import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TDMaterialModule } from '../td.material.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { CommonComponentsModule, PipesModule } from '@terradotta/commons';
import { RouterModule } from '@angular/router';
import { LoginPortalComponent } from './login-portal/login-portal.component';
import { RegistrationComponent } from './registration/registration.component';
import { LoginFormComponent,acctLockedComponent } from './login-form/login-form.component';
import { ApplicationCycleComponent } from './application-cycle/application-cycle.component';
import { AgmCoreModule } from '@agm/core';
import { PasswordResetComponent } from './password-reset/password-reset.component';


@NgModule({
  imports: [
    CommonModule,
    TDMaterialModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    FormsModule,
    NgxMatSelectSearchModule,
    CommonComponentsModule,
    RouterModule,
    AgmCoreModule,
    PipesModule
  ],
  declarations: [LoginPortalComponent, RegistrationComponent, LoginFormComponent, ApplicationCycleComponent, PasswordResetComponent,acctLockedComponent],
  exports: [LoginPortalComponent, RegistrationComponent, LoginFormComponent,acctLockedComponent]
})
export class LoginModule { }
